import React, { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";

class lastFooter extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].lastFooter

    return (
      <div className="container-fluid last-footer">

        <div className="row">
          <div className="container">
            <div className="flex-row">
              <div className="flex-item regular" dangerouslySetInnerHTML={{ __html: langPlace.content }}>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default connect(
  (state) => ({settings: state.settings})
)(lastFooter)



// WEBPACK FOOTER //
// ./src/shared/routes/components/lastFooter.js